import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { LoadableComponent } from "react-loadable";
import { ROUTE_URL, URL_PREFIX } from "../../../components/common/const";
import featureToggles from "../../../config/feature-toggles.malaysia";
import {
  UserProps,
  withUser,
} from "@customer-tools-web/component-authentication";

type Props = UserProps & RouteComponentProps;
export default function (
  ComposedComponent:
    | (React.ComponentClass<any, any> & LoadableComponent)
    | (React.FC<any> & LoadableComponent)
) {
  const PermissionsGuard: React.FC<Props> = (props: Props) => {
    const isLeadsV2: boolean = props?.location?.pathname?.includes(
      ROUTE_URL.leads.v2.detail
    );

    // check if LEAD_MANAGEMENT toggle is ON
    React.useEffect(() => {
      if (isLeadsV2 && !featureToggles.LEAD_MANAGEMENT) {
        props.history?.push(`${URL_PREFIX}/non-existingpage`);
      }
    }, []);

    // check if user has permission to view lead
    React.useEffect(() => {
      if (isLeadsV2 && !props.user?.permissions?.lead?.canViewLead) {
        props.history?.push(`${URL_PREFIX}/non-existingpage`);
      }
    }, [props.user?.permissions]);

    // NOTE: Lead details are allowed on desktop and mobile.

    return <ComposedComponent {...props} />;
  };

  return withUser(withRouter(PermissionsGuard));
}
